import api from './api';

export const listLessonProgress = async (params = {}) => {
  const { data } = await api.get('/lesson-progress', { params });
  return data;
};

export const upsertLessonProgress = async (payload) => {
  const { data } = await api.post('/lesson-progress', payload);
  return data;
};

export default {
  listLessonProgress,
  upsertLessonProgress,
};
